import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { toast } from 'react-toastify';
import { Authentication, updateStatus } from '../../../helpers/adipiBackendUrl';
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";
import {
  ADD_NEW_USER,
  DELETE_USER,
  GET_OPERATIVES,
  GET_TECHADVISORS,
  GET_USERS,
  UPDATE_OPERATIVE_CHECK,
  UPDATE_TECHADVISOR_CHECK,
  UPDATE_USER,
  UPDATE_USER_CHECK,
  UPDATE_USER_STATUS
} from "./actionTypes";
import {
  addUserFail,
  addUserSuccess,
  deleteUserFail,
  deleteUserSuccess,
  getOperativesFail,
  getOperativesSuccess,
  getTechAdvisorsFail,
  getTechAdvisorsSuccess,
  getUsersFail,
  getUsersSuccess,
  setState,
  updateOperativeCheck,
  updateTechAdvisorCheck,
  updateUserCheck,
  updateUserFail,
  updateUserSuccess,
} from "./actions";


//Include Both Helper File with needed methods

function* fetchUsers( { payload: { params } } ) {
  try {
    yield put(setState(true))
    const response = yield call(getTable, Authentication, params.toString());
    yield put(setState(false))
    yield put(getUsersSuccess(response.items,response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false))
    yield put(getUsersFail(error));
  }
}

function* fetchOperatives( { payload: { params } } ) {
  try {
    yield put(setState(true))
    const response = yield call(getTable, Authentication, params.toString());
    yield put(setState(false))
    yield put(getOperativesSuccess(response.items,response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false))
    yield put(getOperativesFail(error));
  }
}

function* fetchTechAdvisors( { payload: { params } } ) {
  try {
    yield put(setState(true))
    const response = yield call(getTable, Authentication, params.toString());
    yield put(setState(false))
    yield put(getTechAdvisorsSuccess(response.items,response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false))
    yield put(getTechAdvisorsFail(error));
  }
}

function* updateUser ({payload: userObj }) {
  try {
    const { id, ...rest } = userObj;
    yield call(patchApiCall, `${Authentication}/${id}`, rest);
    const response = yield call(getTable,`${Authentication}/${userObj.id}`);
    yield put(updateUserSuccess(response));
    toast.success('Registro actualizado correctamente')

  } catch (error) {
    yield put(updateUserFail(error));
    toast.error('Error al actualizar el registro')

  }
}

function* updateUserStatus ({payload: userObj }) {
  try {
    yield call(patchApiCall, `${Authentication}/${updateStatus}/${userObj.id}`, { recordStatus: userObj.recordStatus });
    const response = yield call(getTable,`${Authentication}/${userObj.id}`);
    yield put(updateUserSuccess(response));
  } catch (error) {
    yield put(updateUserFail(error));
  }
}

function* deleteUser ({payload: userObj}) {
  try {
    yield call(deleteApiCall, `${Authentication}/${userObj.id}`);
    yield put(deleteUserSuccess(userObj.id));
    toast.success('Registro borrado correctamente')
  } catch (error) {
    yield put(deleteUserFail(error));
    toast.error('Error al borrar el registro')
  }
}

function* postingUser ({ payload: user}) {
  try {
    const response = yield call(postApiCall, `${Authentication}/register` ,user);
    const response1 = yield call(getTable,`${Authentication}/${response.id}`);
    yield put(addUserSuccess(response1));
    toast.success('Registro agregado correctamente')
  } catch (error) {
    yield put(addUserFail(error));
    toast.error('Error al agregar el registro')
  }
}

function* usersSaga() {
  yield takeEvery(GET_USERS, fetchUsers);
  yield takeEvery(GET_OPERATIVES, fetchOperatives);
  yield takeEvery(GET_TECHADVISORS, fetchTechAdvisors);
  yield takeEvery(ADD_NEW_USER, postingUser);
  yield takeEvery(UPDATE_USER, updateUser);
  yield takeEvery(UPDATE_USER_STATUS, updateUserStatus);
  yield takeEvery(DELETE_USER, deleteUser);
  yield takeEvery(UPDATE_USER_CHECK, updateUserCheck);
  yield takeEvery(UPDATE_OPERATIVE_CHECK, updateOperativeCheck);
  yield takeEvery(UPDATE_TECHADVISOR_CHECK, updateTechAdvisorCheck);
}

export default usersSaga;
